import classNames from "classnames";
import { useRouter } from "next/router";
import { FiChevronRight } from "react-icons/fi";
import { numericToStringThousands } from "../../../../utils/number";
import { postMessageToBuyerApp } from "../../../../utils/post-message";
import { SellerPageRouter } from "../../page-router.props";
import styles from "./floating-cart.module.css";

interface Props {
  productCount: number;
  totalOrderPrice: number;
}

export const FloatingCart: React.FC<Props> = ({
  productCount,
  totalOrderPrice,
}) => {
  const router: SellerPageRouter = useRouter();

  const goToCartPage = () => {
    if (router.query.fromapp) {
      postMessageToBuyerApp("cart-floating-button");
      return;
    }
    router.push(`${router.query.seller}/cart/`);
  };

  if (!productCount || productCount === 0) return null;

  return (
    <div
      className={classNames(styles.container, {
        "bottom-4": router.query.fromapp,
      })}
    >
      <div className="mx-4">
        <button
          onClick={goToCartPage}
          className="bg-primary text-custombg w-full rounded-lg px-5 py-2.5 hover:bg-primary-500"
          id="product-floating-cart-btn"
          data-testid="product-floating-cart-btn"
        >
          <div className="flex items-center justify-between">
            <div className="flex flex-col items-start">
              <span className="text-xs font-bold">Pesanan</span>
              <span className="text-label-md font-medium">
                {productCount} Produk
              </span>
            </div>

            <div className="flex items-center">
              <span className="text-label-md font-medium pr-2">
                Rp{numericToStringThousands(totalOrderPrice)}
              </span>
              <FiChevronRight size={24} />
            </div>
          </div>
        </button>
      </div>
    </div>
  );
};
